// noinspection DuplicatedCode

import {Form} from "../../helpers/forms/Form";
import {initTomSelectInput} from "../../helpers/inputs/tom-select/tom-select";
import {fillInputsByName} from "../../helpers/forms";
import {getSingleInputElementByNameV3} from "../../helpers/forms/formInputsHelpers";
import {initFlatPickerInput} from "../../helpers/inputs/flatPicker/flatPicker";
import {initShirtSizeInput} from "../../helpers/inputs/shirtSizeSelect/shirtSizeSelect";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts
class PublicAuditionRequestPersonalForm extends Form {
	constructor(config) {
		super({
			fields: [
				'first_name',
				'last_name',
				'address',
				'city',
				'state',
				'zip',
				'phone',
				'email',
				'gender',
				'date_of_birth',
				'is_veteran',
				'skip_auditions',
				'has_worked_before',
				'audition_type',
				'shirt_size',

				'form_source_type',
				'form_source_id',
			],
			...config,
		});

		// Setup audition type
		/** @var {HTMLInputElement} */
		this.auditionTypeSelect = this.config.formElement.querySelector('select[name="audition_type"]');

		this.auditionTypeSelectInstance = initTomSelectInput(this.auditionTypeSelect, {
			allowEmptyOption: true,
			onDropdownOpen: () => {
				setTimeout(() => this.scrollFormToBottom())
			}
		})

		this.auditionTypeSelect.addEventListener('change', () => this.handleTypeChange());

		// Setup DOB picker
		this.dobElement = getSingleInputElementByNameV3(this.config.formElement, 'date_of_birth');

		initFlatPickerInput(this.dobElement, {
			enableTime: false,
			maxDate: 'today',
		});

		// Setup shirt size
		const shirtSizeInput = getSingleInputElementByNameV3(this.config.formElement, 'shirt_size');
		if (shirtSizeInput) {
			initShirtSizeInput(shirtSizeInput);
		}

		// Setup previous role checkbox and select
		const previousRoleSelect = this.config.formElement.querySelector('select[name="previous_roles"]')

		this.previousRoleSelectInstance = initTomSelectInput(previousRoleSelect, {
			onDropdownOpen: () => {
				setTimeout(() => this.scrollFormToBottom())
			},
			plugins: [
				'dropdown_input',
				'remove_button'
			]
		});

		this.veteranCheckbox = this.config.formElement.querySelector('input[name="is_veteran"]')
		this.veteranCheckbox.addEventListener('change', () => this.handleSkipAuditionsCheckboxChange());

		this.skipAuditionCheckbox = this.config.formElement.querySelector('input[name="skip_auditions"]')


		// First render
		this.handleSkipAuditionsCheckboxChange();
		this.handleTypeChange();
	}

	handleSkipAuditionsCheckboxChange() {
		const previousRoleContainer = this.config.formElement.querySelector('.previous-role-container');

		previousRoleContainer.classList.toggle('d-none', !this.veteranCheckbox.checked)

		if (this.veteranCheckbox.checked) {
			this.scrollFormToBottom();
		} else if (this.skipAuditionCheckbox) {
			// Clear skip audition checkbox
			this.skipAuditionCheckbox.checked = false;
		}
	}

	handleTypeChange() {
		const type = this.auditionTypeSelect.value;

		if (type === 'cast') {
			// Show all casts only containers
			this.config.formElement
				.querySelectorAll('.cast-only-container')
				.forEach(container => container.classList.remove('d-none'))

		} else {
			// Hide all casts only containers
			this.config.formElement
				.querySelectorAll('.cast-only-container')
				.forEach(container => container.classList.add('d-none'))

			// Clear veteran flag
			fillInputsByName(this.config.formElement, {
				is_veteran: false,
			})
		}
	}

	scrollFormToBottom() {
		// Get immediate parent and scroll it down
		const parent = this.config.formElement.parentElement;

		// Scroll to bottom
		parent.scrollTop = parent.scrollHeight + 100;
	}

	getValues() {
		const data = super.getValues()

		// Add previous role array if required
		// noinspection JSUnresolvedReference
		if (data.is_veteran) {
			// noinspection JSUnresolvedReference
			data.previous_roles = this.previousRoleSelectInstance.getValue().map(roleId => {
				return {
					role_id: roleId,
				}
			});
		}

		return data;
	}
}

export {PublicAuditionRequestPersonalForm}
